import { Box } from '@material-ui/core';
import classNames from 'classnames';
import { SGSForm, SGSFormDate, SGSRadioCtr } from 'components';
import { formHasField } from 'features/arretTravail/models/scenarii';
import { filterRepriseOptions, RepriseOptions } from 'features/arretTravail/models/StopInformation/reprise';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import styles from '../../../../css/ArretTravail.module.scss';

type RepriseSectionProps = {
    scenario: any;
    store: any;
};

export const Reprise: React.FC<RepriseSectionProps> = ({ scenario, store }) => {
    const { watch, getValues, setValue } = useFormContext();

    const WatchReturnedToWork = watch('workStoppage.infos.returnToWorkCod');
    const hasReprise = formHasField(['workStoppage.infos.returnToWorkDate'], 'formAtFields', store);

    useEffect(() => {
        if (WatchReturnedToWork === RepriseOptions.Non) {
            setValue('workStoppage.infos.returnToWorkDate', null);
            delete store?.workStoppage?.infos?.returnToWorkDate;
        }
    }, [WatchReturnedToWork, setValue]);

    if (!hasReprise) {
        delete store?.workStoppage?.infos?.returnToWorkCod;
        return null;
    }

    return (
        <>
            <Box className={classNames(styles.title, 'mb-4')}>Reprise :</Box>
            <SGSForm.Row>
                <SGSForm.Col md={12}>
                    <SGSRadioCtr row options={filterRepriseOptions(scenario?.repriseOptions)} name="workStoppage.infos.returnToWorkCod" label="workStop.fields.workStoppage.infos.returnToWork" />
                </SGSForm.Col>
            </SGSForm.Row>
            {WatchReturnedToWork && WatchReturnedToWork !== RepriseOptions.Non && (
                <SGSForm.Row>
                    <SGSForm.Col md={6}>
                        <SGSFormDate
                            inputVariant="outlined"
                            name="workStoppage.infos.returnToWorkDate"
                            label="workStop.fields.workStoppage.infos.returnToWorkDate"
                            minDate={moment(getValues('workStoppage.infos.start')).add(1, 'days')}
                        />
                    </SGSForm.Col>
                </SGSForm.Row>
            )}
        </>
    );
};

export default Reprise;
